export const includesAll = (array, candidates) => {
  return candidates.every(item => array.includes(item));
};
export const excludesAll = (array, candidates) => {
  return candidates.every(item => !array.includes(item));
};
export const includesAny = (array, candidates) => {
  return candidates.some(item => array.includes(item));
};